import { render } from "./ChatList.vue?vue&type=template&id=07d7b5e2"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
script.render = render

export default script